export interface SearchMatch {
    score: number;
    contentKey: string;
    default: string;
    sns?: string;
    asn?: string;
    reb?: string;
    blg?: string;
}

export interface SearchResult {
    actionType: 'internalLink' | 'externalLink' | 'action' | 'accordion' | 'none';
    name: string;
    link: string;
    title: string;
    routeKey: string;
    subTitle: string;
    score: number;
}

export interface ResultItem {
    product: string;
    path: string;
    routeKey: string;
}

export interface SearchOptions {
    variant: SearchVariant;
    isBusiness: boolean;
}

export enum SearchVariant {
    DEFAULT = 'default',
    MODAL = 'modal'
}
